import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer style={{
      background: 'var(--bg-primary)',
      borderTop: '1px solid var(--border-subtle)',
      padding: '60px 7.6923% 40px',
      marginTop: '100px'
    }}>
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
        gap: '60px',
        paddingBottom: '40px',
        borderBottom: '1px solid var(--border-subtle)'
      }}>
        {/* Company Info */}
        <div>
          <div style={{ 
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            marginBottom: '16px'
          }}>
            <span style={{ 
              fontSize: '26px', 
              fontWeight: 700, 
              color: 'var(--brand-primary)',
              letterSpacing: '-0.8px'
            }}>
              Futura
            </span>
            <span style={{ 
              fontSize: '26px', 
              fontWeight: 300, 
              color: 'var(--text-primary)',
              letterSpacing: '-0.5px'
            }}>
              Softwares
            </span>
          </div>
          <p style={{ 
            fontSize: '16px', 
            color: 'var(--text-secondary)',
            lineHeight: '1.6',
            marginBottom: '24px'
          }}>
            AI systems for a decarbonised future.
          </p>
          <div style={{ display: 'flex', gap: '16px' }}>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{
              color: 'var(--text-muted)',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
            onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
            >
              <Linkedin size={24} />
            </a>
            <a href="mailto:info@futura-softwares.com" style={{
              color: 'var(--text-muted)',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
            onMouseLeave={(e) => e.target.style.color = 'var(--text-muted)'}
            >
              <Mail size={24} />
            </a>
          </div>
        </div>

        {/* Services */}
        <div>
          <h3 style={{ 
            fontSize: '18px', 
            fontWeight: 600, 
            color: 'var(--text-primary)',
            marginBottom: '16px'
          }}>
            Services
          </h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '12px' }}>
              <Link to="/ai-tools" style={{
                color: 'var(--text-secondary)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                AI Tools & Agents
              </Link>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <Link to="/climate-strategy" style={{
                color: 'var(--text-secondary)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                HFC & CO₂ Strategy
              </Link>
            </li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h3 style={{ 
            fontSize: '18px', 
            fontWeight: 600, 
            color: 'var(--text-primary)',
            marginBottom: '16px'
          }}>
            Company
          </h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '12px' }}>
              <Link to="/about" style={{
                color: 'var(--text-secondary)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                About Us
              </Link>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <Link to="/case-studies" style={{
                color: 'var(--text-secondary)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                Case Studies
              </Link>
            </li>
            <li style={{ marginBottom: '12px' }}>
              <Link to="/insights" style={{
                color: 'var(--text-secondary)',
                textDecoration: 'none',
                fontSize: '16px',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
              onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
              >
                Insights
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h3 style={{ 
            fontSize: '18px', 
            fontWeight: 600, 
            color: 'var(--text-primary)',
            marginBottom: '16px'
          }}>
            Contact
          </h3>
          <div style={{ display: 'flex', alignItems: 'start', gap: '8px', marginBottom: '12px' }}>
            <MapPin size={20} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
            <p style={{ fontSize: '16px', color: 'var(--text-secondary)', margin: 0 }}>
              Amsterdam, Netherlands
            </p>
          </div>
          <div style={{ display: 'flex', alignItems: 'start', gap: '8px', marginBottom: '12px' }}>
            <Mail size={20} style={{ color: 'var(--brand-primary)', marginTop: '2px' }} />
            <a href="mailto:info@futura-softwares.com" style={{ 
              fontSize: '16px', 
              color: 'var(--text-secondary)',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
            onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
            >
              info@futura-softwares.com
            </a>
          </div>
          <div style={{ display: 'flex', alignItems: 'start', gap: '8px' }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ color: 'var(--brand-primary)', marginTop: '2px' }}><circle cx="12" cy="12" r="10"/><path d="M2 12h20"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
            <a href="https://www.futura-softwares.com" target="_blank" rel="noopener noreferrer" style={{ 
              fontSize: '16px', 
              color: 'var(--text-secondary)',
              textDecoration: 'none',
              transition: 'color 0.3s ease'
            }}
            onMouseEnter={(e) => e.target.style.color = 'var(--brand-primary)'}
            onMouseLeave={(e) => e.target.style.color = 'var(--text-secondary)'}
            >
              www.futura-softwares.com
            </a>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div style={{
        maxWidth: '1400px',
        margin: '0 auto',
        paddingTop: '30px',
        textAlign: 'center'
      }}>
        <p style={{ fontSize: '14px', color: 'var(--text-muted)' }}>
          © 2025 Futura Softwares BV. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
